/**
 * m.paged-filter -- filter for paging support
 */
// usage: <tr ng-repeat="kirj in vm.tosite.entries | mPaged:vm.pageSize:vm.currPage-1">
export default function () {
    return function (input, pageSize, startPageIdx) {
        if (input && pageSize) {
            startPageIdx = startPageIdx ? parseInt(startPageIdx) : 0;
            pageSize = parseInt(pageSize);
            if (pageSize < input.length) {
                return input.slice(startPageIdx * pageSize, (startPageIdx + 1) * pageSize);
            }
        }
        return input;
    };
}
